import { Icon } from '../components/Icon';
import { CTAS } from '../content/site';
import type { ApplicationResponse } from '../lib/api';

export function Confirmation({ result }: { result: ApplicationResponse }) {
  return (
    <div className="rounded-3xl border border-line bg-white p-8 text-center shadow-card sm:p-12">
      <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-aurora text-white">
        <Icon name="check" className="h-8 w-8" title="Application received" />
      </span>
      <h3 className="mt-6 font-heading text-2xl font-bold text-ink-900">
        Your application is in. Thank you.
      </h3>
      <p className="mx-auto mt-3 max-w-md text-ink-700">
        Our partnerships team will review your campaign and get back to you. We will check brand
        fit, prize details and feasibility before we set anything up.
      </p>

      <div className="mx-auto mt-6 inline-flex items-center gap-2 rounded-xl bg-surface-muted px-4 py-2 font-heading text-sm font-semibold text-ink-900">
        <Icon name="shield" className="h-4 w-4 text-primary-600" />
        Reference: <span className="text-primary-700">{result.reference}</span>
      </div>

      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <a href={CTAS.bookCall.href} className="btn-primary">
          {CTAS.bookCall.label}
        </a>
        <a href={CTAS.requestPack.href} className="btn-secondary">
          {CTAS.requestPack.label}
        </a>
      </div>

      <p className="mt-6 text-xs text-ink-500">
        We will only ever share participant details with you where a participant has given clear,
        recorded, campaign-specific consent.
      </p>
    </div>
  );
}

export default Confirmation;
